import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const buildAddAssociatedContractToPolicy = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		associatedContractId,
		store
	}) {
		const query = gql`
			mutation addAssociatedContractToPolicy(
				$policyId: String!
				$endorsementId: String
				$associatedContractId: String!
			) {
				addAssociatedContractToPolicy(
					policyId: $policyId
					endorsementId: $endorsementId
					associatedContractId: $associatedContractId
				) {
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, associatedContractId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addAssociatedContractToPolicy, store)
		return {
			status: res?.data?.addAssociatedContractToPolicy?.status,
			id: res?.data?.addAssociatedContractToPolicy?.createdStatus?.id
		}
	}
}

const buildRemoveAssociatedContractFromPolicy = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		associatedContractId,
		store
	}) {
		const query = gql`
			mutation removeAssociatedContractFromPolicy(
				$policyId: String!
				$endorsementId: String
				$associatedContractId: String!
			) {
				removeAssociatedContractFromPolicy(
					policyId: $policyId
					endorsementId: $endorsementId
					associatedContractId: $associatedContractId
				) {
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, associatedContractId }
		const res = await api({ query, variables })
		errorHandler(
			res?.errors,
			res?.data?.removeAssociatedContractFromPolicy,
			store
		)
		return {
			status: res?.data?.removeAssociatedContractFromPolicy?.status,
			id: res?.data?.removeAssociatedContractFromPolicy?.createdStatus?.id
		}
	}
}

export {
	buildAddAssociatedContractToPolicy,
	buildRemoveAssociatedContractFromPolicy
}
